import { render } from "./EmployeeBulkReassign.vue?vue&type=template&id=89024df2&ts=true"
import script from "./EmployeeBulkReassign.ts?vue&type=script&lang=ts&external"
export * from "./EmployeeBulkReassign.ts?vue&type=script&lang=ts&external"

import "./EmployeeBulkReassign.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__